import React, { useEffect, useState, useContext } from 'react'
import {
    Dialog, Typography, Card, CardContent,
    Box, Stack, Container, styled, Button, Divider, Grid,
    DialogActions, DialogContent, DialogContentText, DialogTitle,
    AppBar, Toolbar
} from '@mui/material';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { useLocation } from 'react-router-dom';
import { getWorkOrderDetailByReferenceCode } from '../../api/ServiceRequest'
import * as dict from '../../dictionary'
import { ProfileContext } from '../../contexts/ProfileContext';
import { useTheme } from '@mui/material/styles';
import { StatusTag } from './StatusTag';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import moment from 'moment';
import 'moment/locale/th'
import { useNavigate } from 'react-router-dom';
import { CardResponse, BackDropLoading, ModalError } from '../../ui-component/index';
import { checkBase64 } from '../../utils/checkBase64';
import Hashids from 'hashids';
import { getRoomTypeName } from './GetRoomTypeName';
import { saveWorkOrderStatus } from '../../api/ServiceRequest';

export const ServiceRequestDetail = (props) => {
    const domain = window.location.origin
    if (props?.version === "fastcare") {
        document.title = "Fast Care"
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = domain + "/fast-favicon.ico";
    }

    const [detail, setDetail] = useState(null)
    const [alertDialogCancel, setAlertDialogCancel] = useState(false)
    const [profile, setProfile] = useState(null)
    const [houseInfo, setHouseInfo] = useState(null)
    const [openFormCancel, setOpenFormCancel] = useState({ open: false, title: "" })
    const [openFormAppoint, setOpenFormAppoint] = useState({ open: false, title: "" })
    const [modalError, setModalError] = useState({ open: false, error: { status: "", message: "" } });
    const [activityDetailFast, setActivityDetailFast] = useState(null)
    const [photosFast, setPhotosFast] = useState(null)
    const [alertSuccess, setAlertSuccess] = useState({ open: false, title: "" });
    const [loading, setLoading] = useState(false);
    const [lang, setLang] = useState(sessionStorage.getItem("fast-lang") || "th");

    const theme = useTheme()
    const context = useContext(ProfileContext)
    const location = useLocation()
    const navigate = useNavigate()
    const typeOpenReviewBtn = ["ปิดใบงาน", "complete", "ปิดใบงาน (มีเงื่อนไข)", "complete-t"]

    const progressItem = detail?.wo_item?.find(item => item.wo_item_progress_percent != null);

    const handleCloseDialogCancel = () => setAlertDialogCancel(false)
    var params = new URLSearchParams(location.search);
    var unitText = params.get("unitText")
    const referenceCode = location.state?.reference_code;
    var projectInfo
    if (checkBase64(unitText)) {
        projectInfo = window.atob(unitText)
    }

    // const hashids = new Hashids("Yzk5MGIyNTgzZDc0YjMzMzJkNDFkM2ZmYjBhYzM3MWY=",32);
    // let client_id = parseInt(projectInfo?.split("|")[0]) || 0;   
    // let fast_url = projectInfo?.split("|")[1] || "";
    // const s = hashids.encode([133, 1]); //fixed เป็น 1 ไว้ก่อน
    // let pathPdf = `${fast_url}/api/v1/workOrder/print-service-request/${s}?lang=${lang}`;

    // console.log("client_id", client_id); 
    // console.log("encode values:", [client_id, 1]);

    const [pathPdf, setPathPdf] = useState("");

    const fetchWorkOrderInfo = async () => {
        if (!referenceCode || !projectInfo) return null;
        
        try {
            const client_id = parseInt(projectInfo.split("|")[0]);
            const client_url = projectInfo.split("|")[1];
            const project_id = parseInt(projectInfo.split("|")[2]);
            const company_code = profile?.company_code;
            const project_ref_id = houseInfo?.project_id;
            const res = await getWorkOrderDetailByReferenceCode({
                client_id,
                client_url : client_url || profile?.url_api_fast_inspect.split("/api/v1")[0],
                project_id,
                company_code,
                project_ref_id,
                reference_code: referenceCode,
                version: props?.version
            });

            if (res) {
                return {
                    wo_id: res?.wo_id,
                    detail: res,
                    document_pdf_url: res?.document_pdf_url
                };
            }

            return null;
        } catch (err) {
            console.error(err);
            return null;
        }
    };

    const handleCloseTicket = async () => {
        if (!detail) return;

        setLoading(true);
        const client_url = projectInfo.split("|")[1];
        try {
            const res = await saveWorkOrderStatus({
                client_id: detail.client_id,
                work_order: [
                    {
                        ...detail,
                        wo_status: "P"
                    }
                ],
                client_url: client_url || profile?.url_api_fast_inspect.split("/api/v1")[0],
            });

            setLoading(false);

            const isSuccess = res?.status?.toUpperCase() === "SUCCESS";

            if (isSuccess) {
                // ตัด domain ออก
                let msg = res?.message || dict.SUCCESS_CLOSE_TICKET_TXT[profile?.language || lang];
                msg = msg.replace(window.location.origin, "").trim();

                // เปิด modal success
                setAlertSuccess({ open: true, title: msg });

                // อัปเดต detail เพื่อให้ปุ่มหาย
                setDetail({ ...detail, wo_status: "P" });
            } else {
                let msg = res?.message || dict.FAILED_CLOSE_TICKET_TXT[profile?.language || lang]
                msg = msg.replace(window.location.origin, "").trim();

                // เปิด modal error
                setModalError({ open: true, error: { status: res.status, message: msg } });
            }
        } catch (err) {
            setLoading(false);
            console.error("saveWorkOrderStatus error:", err);
            let msg = err?.message || (( profile?.language  === "th" || lang === "th") ? "เกิดข้อผิดพลาด" : "An error occurred");
            msg = msg.replace(window.location.origin, "").trim();
            setModalError({ open: true, error: { status: err?.response?.status, message: msg } });
        }
    };

    useEffect(() => {
        const generatePdfPath = async () => {
            if (!checkBase64(unitText)) return;

            const projectInfoDecoded = window.atob(unitText);
            const client_id = parseInt(projectInfoDecoded?.split("|")[0]) || 0;
            let fast_url = projectInfoDecoded?.split("|")[1] || "";
            if (props?.version !== "fastcare") {
                fast_url = profile?.url_api_fast_inspect.split("/api/v1")[0];
            }
            const workOrderInfo = await fetchWorkOrderInfo();
            if (!workOrderInfo?.wo_id) return;

            const hashids = new Hashids("Yzk5MGIyNTgzZDc0YjMzMzJkNDFkM2ZmYjBhYzM3MWY=", 32);
            const s = hashids.encode([client_id, workOrderInfo.wo_id]);
            setPathPdf(`${fast_url}/api/v1/workOrder/print-service-request/${s}?lang=${profile?.language || lang}` + (profile?.company_code ? `&company_code=${profile?.company_code}` : ''));

            setDetail(workOrderInfo.detail);
        };

        generatePdfPath();
    }, [unitText, referenceCode, lang, profile, houseInfo]);

    useEffect(() => {
        const handleLangChange = () => setLang(sessionStorage.getItem("fast-lang") || "th");
        window.addEventListener("storage", handleLangChange);
        return () => window.removeEventListener("storage", handleLangChange);
    }, []);

    useEffect(() => {
        setDetail(location.state)
    }, [location.state])

    useEffect(() => {
        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }
        if (context.state?.houseInfo !== null) {
            setHouseInfo(context.state?.houseInfo)
        }
    }, [context])

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <AppBar sx={{ position: 'fixed', boxShadow: 'none', height: 60 }}>
                <Toolbar>
                    <Grid container item xs={1}>
                        <ArrowBackIos onClick={() => {

                            if (props?.version === "fastcare") {
                                const params = new URLSearchParams(location.search);
                                params.delete('reference_code');
                                navigate(`/service-request/list?${params.toString()}`)
                            } else {
                                // กรณี Line OA: ให้ย้อนกลับไปหน้าก่อนหน้า (dynamic)
                                navigate(-1);
                            }
                        }} />
                    </Grid>
                    <Grid container item xs={10} direction="row" justifyContent="center">
                        <Typography>
                            {dict.REQUEST_NO_TXT[profile?.language || lang]} {detail?.reference_code}
                        </Typography>
                    </Grid>
                </Toolbar>
            </AppBar>

            <Container
                sx={{
                    mt: props?.version === "fastcare" ? 8 : 0,
                    mb: 2,
                    flex: 1,
                    minHeight: 'calc(100vh - 60px)',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                }}
            >
                <Stack direction={"row"} justifyContent={"flex-start"}>
                    <Typography variant="h5" mt={2}>
                        {dict.SEQ_WORK_TYPE_NAME_TXT[profile?.language || lang]}
                    </Typography>
                </Stack>

                <Box mt={2}>
                    <Card variant="outlined" sx={{ width: "100%", boxShadow: "0px 0px 7px 0px #00000040" }}>
                        <CardContent>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>
                                    {dict.CONTRACT_UNIT_TYPE_TXT[profile?.language || lang]}
                                </Typography>
                                <Typography variant='caption'>{getRoomTypeName(detail?.contract_unit_type, profile?.language || lang)}</Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.PERCENT_OF_PROGRESS_TXT[profile?.language || lang]}</Typography>
                                <Typography variant="caption">
                                    {progressItem
                                        ? `${progressItem.wo_item_progress_percent}%`
                                        : "-"}
                                </Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.SERVICE_REQUEST_LIST_Status_TXT[profile?.language || lang]}</Typography>
                                <StatusTag code={detail?.wo_status} lang={profile?.language || lang} version={props?.version} />
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.REQUEST_DATE_TXT[profile?.language || lang]}</Typography>
                                <Typography variant='caption'>{detail?.wo_opened_date ? moment(detail.wo_opened_date).format("DD/MM/YYYY") : "-"}</Typography>
                            </Stack>

                            <Stack mt={2} direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                                <Typography variant='h6'>{dict.SERVICE_REQUEST_LIST_DETAIL_TXT[profile?.language || lang]}</Typography>
                            </Stack>

                            <Box>
                                <Typography variant='body2' paragraph={true} sx={{ wordWrap: "break-word" }}>
                                    <Typography variant='caption'>{detail?.wo_note || "-"}</Typography>
                                </Typography>
                            </Box>

                            {location?.state?.version === "fast" && <>
                                <Divider sx={{ marginLeft: -14, marginRight: -14 }} />
                                <Stack direction="row" justifyContent="center" mt={2} spacing={2}>
                                    <Button size="large" sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040", width: "100%" }} onClick={() => window.open(detail?.document_pdf_url)}>
                                        {dict.See_Doc_Defect_TXT[profile?.language || lang]}
                                    </Button>
                                    {typeOpenReviewBtn.includes(detail?.status) &&
                                        <BtnCustom size="large" onClick={() => window.open(detail?.satisfaction_url)}>
                                            <Typography color={theme.palette.secondary.main}>{dict.Review_Defect_TXT[profile?.language || lang]}</Typography>
                                        </BtnCustom>
                                    }
                                </Stack>
                            </>}
                        </CardContent>
                    </Card>

                    <Card variant="outlined" sx={{ width: "100%", boxShadow: "0px 0px 7px 0px #00000040", mt: 2 }}>
                        <CardContent>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant="h6">{dict.PRINT_DOCUMENT_TXT[profile?.language || lang]}</Typography>
                            </Stack>

                            <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => window.open(pathPdf, "_blank")}
                                >
                                    Service Request
                                </Button>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card variant="outlined" sx={{ width: "100%", boxShadow: "0px 0px 7px 0px #00000040", mt: 2 }}>
                        <CardContent>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='h6'>{dict.HISTORY_TXT[profile?.language || lang]}</Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.REQUEST_DATE_TXT[profile?.language || lang]}</Typography>
                                <Typography variant='caption'>{detail?.wo_opened_date ? moment(detail.wo_opened_date).format("DD/MM/YYYY") : "-"}</Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.INSPECTION_DATE_TXT[profile?.language || lang]}</Typography>
                                <Typography variant='caption'>{detail?.wo_start_date ? moment(detail.wo_start_date).format("DD/MM/YYYY") : "-"}</Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.OPERATION_DATE_TXT[profile?.language || lang]}</Typography>
                                <Typography variant='caption'>{detail?.wo_process_date ? moment(detail.wo_process_date).format("DD/MM/YYYY") : "-"}</Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Typography variant='caption'>{dict.CLOSE_DATE_TXT[profile?.language || lang]}</Typography>
                                <Typography variant='caption'>{detail?.wo_finish_date ? moment(detail.wo_finish_date).format("DD/MM/YYYY") : "-"}</Typography>
                            </Stack>
                        </CardContent>
                    </Card>

                    {detail?.wo_status === "C" && (
                        <Card variant="outlined" sx={{ width: "100%", boxShadow: "0px 0px 7px 0px #00000040", mt: 2 }}>
                            <CardContent>
                                <Stack direction={"row"} justifyContent={"space-between"}>
                                    <Typography variant='h6'>{dict.CLOSE_REQUEST_TXT[profile?.language || lang]}</Typography>
                                </Stack>

                                <Stack direction={"row"} justifyContent={"space-between"}>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{ backgroundColor: 'green', color: 'white', '&:hover': { backgroundColor: 'darkgreen' } }}
                                        onClick={handleCloseTicket}
                                    >
                                        Close Ticket
                                    </Button>
                                </Stack>

                            </CardContent>
                        </Card>
                    )
                    }
                </Box>
            </Container>

            {/* Modal ปิดงานสำเร็จ */}
            <Dialog
                open={alertSuccess.open}
                onClose={() => setAlertSuccess({ open: false, title: "" })}
                maxWidth="xs"
                fullWidth
            >
                <DialogContent sx={{ textAlign: "center", py: 3 }}>
                    <Box
                        sx={{
                            mb: 2,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 60,
                            height: 60,
                            borderRadius: "50%",
                            bgcolor: "success.main",
                            color: "white",
                            mx: "auto",
                            fontSize: 30,
                        }}
                    >
                        ✓
                    </Box>
                    <Typography variant="h6" gutterBottom>
                        {dict.SUCCESS_CLOSE_TICKET_TXT[profile?.language || lang]}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {alertSuccess.title}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => setAlertSuccess({ open: false, title: "" })}
                    >
                        {dict.AcceptBtn2_TXT[ profile?.language || lang]}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal ปิดงานไม่สำเร็จ */}
            <Dialog
                open={modalError.open}
                onClose={() => setModalError({ open: false, error: { status: "", message: "" } })}
                maxWidth="xs"
                fullWidth
            >
                <DialogContent sx={{ textAlign: "center", py: 3 }}>
                    <Box
                        sx={{
                            mb: 2,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 60,
                            height: 60,
                            borderRadius: "50%",
                            bgcolor: "error.main",
                            color: "white",
                            mx: "auto",
                            fontSize: 30,
                        }}
                    >
                        ✕
                    </Box>
                    <Typography variant="h6" gutterBottom>
                         {dict.FAILED_CLOSE_TICKET_TXT[profile?.language || lang]} 
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {modalError.error.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => setModalError({ open: false, error: { status: "", message: "" } })}
                    >
                        {dict.AcceptBtn2_TXT[ profile?.language || lang]}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

const BoxHaveImg = styled(Box)(({ theme }) => ({
    width: "100%",
    height: "100%",
    background: `linear-gradient(to right, ${theme.palette.primary.main} 100%, transparent 0%) top repeat-x , linear-gradient(${theme.palette.primary.main} 100%, transparent 60%) right repeat-y, linear-gradient(to right, ${theme.palette.primary.main} 1000%, transparent 0%) bottom repeat-x, linear-gradient(${theme.palette.primary.main} 100%, transparent 0%) left repeat-y`,
    backgroundSize: "20% 3px,3px 20%",
    borderRadius: "5%"
}))

const BtnCustom = styled(Button)(({ theme }) => ({
    borderRadius: "10px",
    boxShadow: "0px 0px 7px 0px #00000040",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    "&:hover": { backgroundColor: theme.palette.primary.main }
}))

const ButtonActivity = styled(Button)(({ theme }) => ({
    width: "100%",
    minHeight: "50px",
    borderRadius: "10px",
    border: "1px",
    boxShadow: "0px 0px 7px 0px #00000040",
    "&:hover": { backgroundColor: theme.palette.primary.main, color: "white" }
}))
